module.exports = __webpack_public_path__ + "static/img/forktail.55b4eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/forktail.png
// module id = +ovj
// module chunks = 0